import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css } from 'styled-components';
export const InitialStyledQueriesProps = {
    $default: undefined,
    $ultra: undefined,
    $wide: undefined,
    $xxl: undefined,
    $xl: undefined,
    $lg: undefined,
    $md: undefined,
    $tablet: undefined,
    $mobile: undefined,
};
export const ContainerContentWidthStyling = ({ theme, $cap, }) => css `
  width: calc(100% - ${theme.spacing.xl}px);
  margin: 0 auto;
  max-width: 450px;
  @media (min-width: ${theme.breakpoints.tablet}px) {
    width: calc(100% - ${theme.spacing.xl}px);
    max-width: calc(${$cap}px - ${theme.spacing.xl}px);
  }

  @media (min-width: ${theme.breakpoints.md}px) {
    width: ${$cap}px;
    max-width: calc(100% - ${theme.spacing.xxl}px);
  }
`;
export const ContainerContentStyled = styled.section `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: fit-content;

  li {
    width: fit-content;
    .hd-text {
      width: fit-content;
      display: inline;
    }
  }

  ${(props) => getMediaQueriesStyling(props)}
`;
const getMediaQueriesStyling = (props) => {
    const { $default, $ultra, $wide, $xxl, $xl, $lg, $md, $mobile, $tablet } = props;
    return css `
    ${$default};
    ${media.ultra `${$ultra}`};
    ${media.wide `${$wide}`};
    ${media.xxl `${$xxl}`};
    ${media.xl `${$xl}`};
    ${media.l `${$lg}`};
    ${media.md `${$md}`};
    ${media.tablet `${$tablet}`};
    ${media.mobile `${$mobile}`};
  `;
};
export const GradientStyling = (theme, size) => css `
  &:after,
  &:before {
    content: '';
    position: absolute;

    left: 0;
    width: 100%;
  }
  &:before {
    top: 0;
    height: ${size}%;
    background: ${theme.colors.beige_1};
  }
  &:after {
    top: ${size}%;
    height: ${100 - size}%;
    background: ${theme.colors.beige_2};
  }
`;
export const ContainerStyled = styled.div `
  position: relative;
  z-index: 1;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) => getMediaQueriesStyling(props)}
`;
